/**
 * Developed by Spell Solutions for Trivinci Systems, LLC.
 *
 * Developer attribution only. Ownership, licensing, and permitted use are
 * governed by the applicable agreement and applicable law.
 */
import { LitElement, css, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { getQuery, normalizeLoggerId } from "../lib/url";
import "./rk-setup";
import "./rk-player";

/**
 * <rk-app> — root shell. Picks between setup screen and the live player based
 * on `?loggerId=`. Also handles popstate so back/forward works.
 */

@customElement("rk-app")
export class RkApp extends LitElement {
  static styles = css`
    :host { display: block; width: 100%; height: 100%; }
  `;

  @state() private loggerId: string | null = null;

  connectedCallback(): void {
    super.connectedCallback();
    this.syncFromUrl();
    window.addEventListener("popstate", this.syncFromUrl);
  }
  disconnectedCallback(): void {
    super.disconnectedCallback();
    window.removeEventListener("popstate", this.syncFromUrl);
  }

  private syncFromUrl = () => {
    const id = getQuery().get("loggerId");
    this.loggerId = id ? normalizeLoggerId(id) : null;
  };

  private onConnect = (ev: CustomEvent<{ loggerId: string }>) => {
    this.loggerId = ev.detail.loggerId;
  };

  render() {
    if (!this.loggerId) {
      return html`<rk-setup @connect=${this.onConnect}></rk-setup>`;
    }
    return html`<rk-player logger-id=${this.loggerId}></rk-player>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rk-app": RkApp;
  }
}
